import React, { HTMLAttributes } from 'react';

import styles from '../styles.module.css';

export interface CardAppointmentTitleProps
  extends HTMLAttributes<HTMLDivElement> {}

export const CardAppointmentTitle: React.FC<CardAppointmentTitleProps> = ({
  children,
  ...props
}) => {
  return (
    <h3 className={styles.cardTitle} {...props}>
      {children}
    </h3>
  );
};
